import { useState } from "react";
import { Plus, HelpCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useLanguage();
  const [openIdx, setOpenIdx] = useState(0);
  const faqs = t.faq.items;

  return (
    <section id="faq" data-testid="faq-section" className="py-16 sm:py-24 lg:py-32 carbon-panel border-t border-zinc-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-4 flex items-center gap-3">
            <HelpCircle size={16} strokeWidth={2} /> {t.faq.eyebrow}
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight leading-tight text-white">
            {t.faq.heading}
          </h2>
        </div>

        <div className="border-t border-zinc-800">
          {faqs.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`} className="border-b border-zinc-800">
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left py-6 group"
                >
                  <span className="font-display font-medium text-lg sm:text-xl uppercase tracking-tight text-white group-hover:text-red-500 transition-colors">
                    {item.q}
                  </span>
                  <span className={`shrink-0 text-red-500 transition-transform duration-300 ${open ? "rotate-45" : ""}`}>
                    <Plus size={24} strokeWidth={2.5} />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-zinc-300 leading-relaxed pb-6 pr-8 max-w-3xl">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
